// App configuration from environment variables

export const config = {
  chatDisplayMode: import.meta.env.VITE_CHAT_DISPLAY_MODE || 'agent', // 'agent' | 'chat'
};
